import createInstanceAddReduxUtil from '../../../../redux/actions/create/create-instance'

export default function createInstancesAddReduxUtil (stateWrapper, payload) {
  return payload.data.reduce((instances, obj) => {
    const instance = createInstanceAddReduxUtil(stateWrapper, {
      data: {
        data: obj,
        status: payload.status
      },
      domainListPath: payload.domainListPath,
      options: payload.options
    })
    instances.push(instance)
    return instances
  }, [])
}
